import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class Constant {
 
  public LogoUrl: 'http://192.168.1.177/logog';

  LOGOURL() {
   return 'http://192.168.1.177/logog';
  }
};
